<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة مشروع عقاري</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link v-if="checkAccess('projects_read')" to="/projects">المشاريع العقارية</router-link><span v-else>المشاريع العقارية</span></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة مشروع</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <ProjectsForm v-if="checkAccess('projects_create')" cardTitle="إضافة مشروع عقاري" @saving="formSaving = $event" />
            <div v-else class="alert alert-warning">ليس لديك صلاحية إضافة المشاريع العقارية.</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import ProjectsForm from './form.vue';

export default {
  name: 'ProjectsCreate',
  components: { ProjectsForm },
  data() { return { formSaving: false }; },
  methods: { checkAccess },
  beforeRouteLeave() { return !this.formSaving; },
};
</script>
